import imagePath from "@/src/paths/imagePath.js";

export const userHeaders = [
  { label: "Email", key: "email", width: 4 },
  { label: "Role", key: "role_name", width: 2 },
  {
    label: "Credit Limit (max usage for 30 days)",
    key: "credit_limit",
    width: 4,
  },
  { label: "", key: "pending", width: 2 },
];

export const superAGIUser = {
  id: -555,
  name: "AI Agent",
  profile_pic: imagePath.neutral.platform.superAGILogoRound,
};
